export const PRODUCT_LICENSE_TYPE_CODES = ['class_c', 'cdl', 'none'] as const;

export type ProductLicenseTypeCode =
  (typeof PRODUCT_LICENSE_TYPE_CODES)[number];

export const PRODUCT_LICENSE_TYPE_OPTIONS: Array<{
  code: ProductLicenseTypeCode;
  label: string;
}> = [
  { code: 'class_c', label: 'Class C' },
  { code: 'cdl', label: 'CDL' },
  { code: 'none', label: 'No License' },
];

const TICKET_LICENSE_TO_CODE: Record<string, ProductLicenseTypeCode> = {
  'class c': 'class_c',
  class_c: 'class_c',
  c: 'class_c',
  cdl: 'cdl',
  'class a': 'cdl',
  'class b': 'cdl',
  none: 'none',
};

const URL_TYPE_TO_TICKET_VALUE: Record<string, string> = {
  'class-c': 'Class C',
  cdl: 'CDL',
  warrant: 'None',
};

export function ticketLicenseTypeToCode(
  value: string | null | undefined,
): ProductLicenseTypeCode | null {
  if (!value?.trim()) return null;
  return TICKET_LICENSE_TO_CODE[value.trim().toLowerCase()] ?? null;
}

export function urlTypeParamToTicketValue(
  value: string | null | undefined,
): string | null {
  if (!value?.trim()) return null;
  return URL_TYPE_TO_TICKET_VALUE[value.trim().toLowerCase()] ?? null;
}

export function licenseTypeCodeToLabel(
  code: string | null | undefined,
): string {
  if (!code) return 'Not set';
  return (
    PRODUCT_LICENSE_TYPE_OPTIONS.find((option) => option.code === code)
      ?.label ?? code
  );
}

export function productMatchesTicketLicenseType(
  productLicenseType: string | null | undefined,
  ticketLicenseType: string | null | undefined,
): boolean {
  const ticketCode = ticketLicenseTypeToCode(ticketLicenseType);
  if (!ticketCode) return true;

  const productCode = productLicenseType?.trim().toLowerCase();
  if (!productCode) return false;

  return productCode === ticketCode;
}
